export default __webpack_public_path__ + "static/media/manufacturing-cost.c41f8a10.svg";